import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { removeProjectContributor } from '@services/projects.service';
import { invalidateProjectQueries } from './projectQueryInvalidation';

/**
 * @param {string} projectId
 * @returns {{ removeContributor: (userId: string) => void, isPending: boolean }}
 */
export function useRemoveProjectContributor(projectId) {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: (userId) => removeProjectContributor(projectId, userId),
        onSuccess: () => {
            invalidateProjectQueries(queryClient, projectId);
            message.success('Member removed from project.');
        },
        onError: (err) => {
            message.error(err?.response?.data?.message || err?.message || 'Failed to remove member.');
        },
    });

    const removeContributor = (userId, callbacks = {}) => {
        mutation.mutate(userId, {
            onSuccess: callbacks.onSuccess,
            onError: callbacks.onError,
        });
    };

    return {
        removeContributor,
        isPending: mutation.isPending,
    };
}
